import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  workunit_reference: string;
};

const WorkunitReferenceCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    {row?.workunit_reference && (
      <Tooltip title={row.workunit_reference}>
        <Typography variant="body2" noWrap>
          {row.workunit_reference}
        </Typography>
      </Tooltip>
    )}
  </>
));

export default WorkunitReferenceCell;
